module.exports = __webpack_public_path__ + "media/images/svgs/icon-facebook-85541cca876a22b38eff9052e18eff03.svg";